<div class="content-inputs" [formGroup]="fg">
  <div class="trigger-setting-selector">
    <app-select-v2
      class="fields-selector"
      placeHolder="Settings Options"
      [options$]="configurationFieldsOptions$"
      [canBeEmpty]="true"
      [selectedId]="selectedFieldToAdd"
      (optionOnSelection)="onConfigurationFieldSelection($event)"
    >
    </app-select-v2>
  </div>

  <div *ngFor="let configuration of selectedConfiguration">
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.resourceType] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.resourceType
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceType' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceTypeOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceTypes', $event)"
          [selectedIds]="fg.controls['resourceTypes'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.resourceType)"
        />
      </div>
      <div class="trigger-setting-warning-container" *ngIf="multipleResourceTypesWarningVisible">
        <img src="assets/images/common/warning.svg" />
        <div>
          {{ 'playbooks.multipleResourceTypeWarningText' | labelsProvider }}
        </div>
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.connectors] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.connectors
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.connectors' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="connectorsOptions$"
          (optionOnSelection)="updateMultiSelectControl('connectors', $event)"
          [selectedIds]="fg.controls['connectors'].value"
          [withSearch]="true"
          [withSelectAll]="true"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.connectors)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.resourceStatus] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.resourceStatus
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.resourceStatus' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceStatusOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceStatus', $event)"
          [selectedIds]="fg.controls['resourceStatus'].value"
          [withSearch]="true"
          [withSelectAll]="true"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.resourceStatus)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.securityRisk] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.securityRisk
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.securityRisk' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceSecurityRiskOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceSecurityRisk', $event)"
          [selectedIds]="fg.controls['resourceSecurityRisk'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.securityRisk)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.businessCriticality] ===
          configurationFieldStateEnum.selected &&
        configuration === newResourceConfigurationFieldEnum.businessCriticality
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.businessCriticality' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceBusinessCriticalityOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceBusinessCriticality', $event)"
          [selectedIds]="fg.controls['resourceBusinessCriticality'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.businessCriticality)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.generativeAiOptions] ===
          configurationFieldStateEnum.selected &&
        configuration === newResourceConfigurationFieldEnum.generativeAiOptions
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.generativeAiOptions' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-multi-select
          class="input-container"
          [placeHolder]="'common.select' | labelsProvider"
          [options$]="resourceGenerativeAiOptions$"
          (optionOnSelection)="updateMultiSelectControl('resourceGenerativeAiOptions', $event)"
          [selectedIds]="fg.controls['resourceGenerativeAiOptions'].value"
        >
        </app-multi-select>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.generativeAiOptions)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.createdBy] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.createdBy
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.createdBy' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <input
          class="input-container trigger-setting-input"
          formControlName="resourceCreatedBy"
          type="text"
          placeholder="Enter email..."
        />
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.createdBy)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.lastModifiedBy] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.lastModifiedBy
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.lastModifiedBy' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <input
          class="input-container trigger-setting-input"
          formControlName="resourceLastModifiedBy"
          type="text"
          placeholder="Enter your text..."
        />
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.lastModifiedBy)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.createdAt] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.createdAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.createdSince' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceCreatedSince', $event)"
          [startingValue]="fg.controls['resourceCreatedSince'].value"
          [newValueTriggered$]="createdSinceDatesBehavioralSubject$"
        >
        </app-date-picker>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.createdAt)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.createdAt] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.createdAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.createdUntil' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceCreatedUntil', $event)"
          [startingValue]="fg.controls['resourceCreatedUntil'].value"
          [minDate]="fg.controls['resourceCreatedUntil'].value"
          [newValueTriggered$]="createdUntilDatesBehavioralSubject$"
        >
        </app-date-picker>
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.firstSeenAt] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.firstSeenAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.firstSeenSince' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceFirstSeenSince', $event)"
          [startingValue]="fg.controls['resourceFirstSeenSince'].value"
          [newValueTriggered$]="firstSeenSinceDatesBehavioralSubject$"
        >
          >
        </app-date-picker>
        <img
          src="assets/images/common/delete.svg"
          class="delete-icon ng-star-inserted"
          (click)="removeSetting(newResourceConfigurationFieldEnum.firstSeenAt)"
        />
      </div>
    </div>
    <div
      class="trigger-setting"
      *ngIf="
        allConfigurationFieldsState[newResourceConfigurationFieldEnum.firstSeenAt] ===
          configurationFieldStateEnum.selected && configuration === newResourceConfigurationFieldEnum.firstSeenAt
      "
    >
      <div class="trigger-setting-title">
        {{ 'playbooks.triggersConfigurationLabels.firstSeenUntil' | labelsProvider }}
      </div>
      <div class="field-value-container">
        <app-date-picker
          class="input-container trigger-setting-date-picker"
          label="tableActionsAndFilters.fromDate"
          (dateOnSelection)="dateSelected('resourceFirstSeenUntil', $event)"
          [startingValue]="fg.controls['resourceFirstSeenUntil'].value"
          [minDate]="fg.controls['resourceFirstSeenSince'].value"
          [newValueTriggered$]="firstSeenUntilDatesBehavioralSubject$"
        >
        </app-date-picker>
      </div>
    </div>
  </div>
</div>
